import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=a45893d2&scoped=true"
import script from "./SubmitButton.vue?vue&type=script&lang=js"
export * from "./SubmitButton.vue?vue&type=script&lang=js"
import style0 from "./SubmitButton.vue?vue&type=style&index=0&id=a45893d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45893d2",
  null
  
)

export default component.exports